var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtfs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 540,
    viewBox: "0 0 1440 540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10830_8003",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -230,
    width: 1440,
    height: 1080
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -230,
    width: 1440,
    height: 1080,
    fill: "url(#paint0_radial_10830_8003)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10830_8003)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10830_8003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1080,
    transform: "translate(0 -230)",
    fill: "#0E122F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.25 183.56H1334.45L1334.51 183.55L1334.5 183.56H1334.51L1334.47 183.58L1332.67 184.88L1333.35 186.99L1333.38 187.04L1333.37 187.03L1333.37 187.04L1333.35 187.015L1331.55 185.711L1329.72 187.04L1330.43 184.884L1328.63 183.58L1328.59 183.56H1328.6L1328.59 183.55L1328.65 183.56H1330.85L1331.55 181.4L1332.25 183.56ZM1322.95 181.05H1325.22L1323.39 182.382L1324.06 184.48L1324.09 184.53L1324.08 184.521L1324.08 184.53L1324.06 184.505L1322.26 183.193L1320.45 184.505L1320.43 184.53L1320.43 184.521L1320.42 184.53L1320.45 184.48L1321.13 182.376L1319.36 181.096L1319.29 181.06H1319.31L1319.3 181.05L1319.36 181.06H1321.56L1322.26 178.9L1322.95 181.05ZM1340.85 178.954L1341.54 181.06H1343.74L1343.8 181.05L1343.79 181.06H1343.8L1343.76 181.08L1341.97 182.378L1342.65 184.48L1342.68 184.53L1342.67 184.521L1342.67 184.53L1342.65 184.505L1340.84 183.196L1339.01 184.53L1339.71 182.38L1337.88 181.05H1340.15L1340.82 178.955L1340.83 178.9L1340.83 178.915L1340.84 178.9L1340.85 178.954ZM1315.47 172.113L1316.15 174.21H1318.36L1318.42 174.2L1318.41 174.21H1318.42L1318.38 174.23L1316.58 175.528L1317.26 177.631L1317.29 177.68L1317.28 177.67L1317.28 177.68L1317.26 177.654L1315.45 176.349L1313.66 177.652L1313.62 177.69L1313.62 177.676L1313.62 177.68L1313.63 177.661L1314.32 175.539L1312.49 174.21H1314.75L1315.44 172.113L1315.45 172.06L1315.45 172.074L1315.46 172.06L1315.47 172.113ZM1347.66 172.113L1348.34 174.21H1350.61L1348.77 175.537L1349.44 177.613L1349.48 177.68L1349.46 177.667L1349.47 177.69L1349.41 177.629L1347.64 176.347L1345.85 177.652L1345.82 177.68L1345.82 177.669L1345.81 177.68L1345.84 177.625L1346.52 175.533L1344.72 174.23L1344.68 174.21H1344.69L1344.68 174.2L1344.74 174.21H1346.95L1347.63 172.113L1347.64 172.06L1347.64 172.074L1347.65 172.06L1347.66 172.113ZM1313.66 164.86H1315.86L1315.92 164.85L1315.91 164.86H1315.92L1315.87 164.883L1314.08 166.189L1314.79 168.34L1312.96 167.011L1311.16 168.315L1311.14 168.34L1311.14 168.33L1311.13 168.34L1311.16 168.29L1311.84 166.185L1310.08 164.897L1310 164.86H1310.02L1310.01 164.85L1310.07 164.86H1312.26L1312.96 162.7L1313.66 164.86ZM1350.15 162.754L1350.83 164.86H1353.03L1353.09 164.85L1353.08 164.86H1353.09L1353.04 164.883L1351.26 166.185L1351.94 168.29L1351.97 168.34L1351.96 168.33L1351.96 168.34L1351.94 168.315L1350.13 167.013L1348.31 168.34L1349.01 166.189L1347.23 164.883L1347.18 164.86H1347.19L1347.18 164.85L1347.24 164.86H1349.44L1350.12 162.755L1350.13 162.7L1350.13 162.715L1350.14 162.7L1350.15 162.754ZM1316.15 155.51H1318.41L1316.58 156.837L1317.26 158.941L1317.29 158.99L1317.28 158.98L1317.28 158.99L1317.26 158.965L1315.45 157.654L1313.69 158.933L1313.63 158.99L1313.64 158.968L1313.62 158.98L1313.65 158.916L1314.33 156.833L1312.53 155.53L1312.49 155.51H1312.5L1312.49 155.5L1312.55 155.51H1314.75L1315.45 153.36L1316.15 155.51ZM1348.35 155.51H1350.54L1350.6 155.5L1350.59 155.51H1350.61L1350.53 155.547L1348.77 156.828L1349.46 158.963L1349.47 158.98L1349.46 158.977L1349.47 158.99L1349.44 158.956L1347.64 157.652L1345.85 158.963L1345.82 158.99L1345.82 158.979L1345.81 158.99L1345.84 158.936L1346.52 156.837L1344.69 155.51H1346.95L1347.65 153.36L1348.35 155.51ZM1322.27 146.563L1322.95 148.66H1325.21L1323.38 149.992L1324.08 152.14L1322.25 150.811L1320.46 152.112L1320.42 152.15L1320.42 152.136L1320.42 152.14L1320.43 152.121L1321.13 149.985L1319.36 148.706L1319.29 148.67H1319.31L1319.3 148.66L1319.36 148.67H1321.56L1322.24 146.564L1322.25 146.51L1322.25 146.524L1322.26 146.51L1322.27 146.563ZM1341.54 148.67H1343.74L1343.8 148.66L1343.79 148.67H1343.8L1343.76 148.69L1341.97 149.988L1342.64 152.073L1342.68 152.14L1342.66 152.127L1342.67 152.15L1342.61 152.089L1340.85 150.811L1339.02 152.14L1339.72 149.986L1337.91 148.675L1337.88 148.66H1340.14L1340.84 146.51L1341.54 148.67ZM1332.25 146.16H1334.45L1334.51 146.15L1334.5 146.16H1334.51L1334.47 146.181L1332.67 147.48L1333.35 149.59L1333.38 149.64L1333.37 149.63L1333.37 149.64L1333.35 149.614L1331.55 148.304L1329.72 149.64L1330.43 147.483L1328.63 146.181L1328.59 146.16H1328.6L1328.59 146.15L1328.65 146.16H1330.85L1331.55 144L1332.25 146.16Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008 202V201.625H1007.62V202H1008ZM1008 274H1007.62V274.375H1008V274ZM1008 202V202.375H1080V202V201.625H1008V202ZM1080 274V273.625H1008V274V274.375H1080V274ZM1008 274H1008.38V202H1008H1007.62V274H1008Z",
    fill: "#785E32"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1027.29 224.26V220.374H1032.11V224.26H1027.29ZM1027.29 241.9V225.971H1032.11V241.894L1027.29 241.9ZM1113.04 235.2H1102.22C1102.42 236.892 1103.65 238.19 1106.02 238.19C1107.47 238.229 1108.87 237.643 1109.88 236.575L1112.76 239.589C1111.28 241.293 1108.94 242.331 1106.03 242.331C1100.51 242.331 1097.26 239.075 1097.26 233.828C1097.26 228.981 1100.4 225.456 1105.36 225.456C1110.33 225.456 1113.21 228.551 1113.21 233.164C1113.23 233.847 1113.17 234.53 1113.04 235.2ZM1108.41 232.151C1108.31 230.497 1107.23 229.319 1105.38 229.319C1103.53 229.319 1102.45 230.485 1102.23 232.151H1108.41ZM1121.24 242.316C1118.86 242.316 1115.95 241.679 1113.8 239.586L1116.55 236.566C1117.82 237.784 1119.49 238.467 1121.23 238.48C1122.91 238.48 1123.64 238.034 1123.64 237.353C1123.64 236.836 1123.27 236.543 1122.36 236.262C1121.55 236.016 1120.29 235.801 1119.23 235.481C1116.91 234.791 1114.61 233.807 1114.61 230.467C1114.61 227.376 1117.08 225.48 1121.2 225.48C1123.48 225.48 1126.05 225.956 1128.22 227.917L1125.44 230.862C1124.22 229.666 1122.53 229.235 1121.16 229.235C1119.92 229.235 1119.23 229.681 1119.23 230.3C1119.23 230.814 1119.6 231.116 1120.53 231.427C1121.35 231.693 1122.69 231.953 1123.75 232.261C1125.97 232.901 1128.27 233.867 1128.27 237.045C1128.28 240.6 1125.34 242.319 1121.24 242.319V242.316ZM1047.03 226.595C1045.81 225.142 1044.01 224.333 1042.13 224.395C1040.1 224.395 1039.04 225.142 1039.04 226.207C1039.04 227.648 1040.64 228.147 1043.72 229.029C1047.09 230.001 1050.93 231.098 1050.93 235.646C1050.93 240.193 1047.23 242.295 1042.55 242.295C1038.61 242.295 1035.39 241.144 1033.32 238.286L1036.92 235.236C1038.29 237.123 1040.37 237.891 1042.5 237.891C1045.02 237.891 1045.94 236.994 1045.94 236.022C1045.94 234.611 1044.48 234.267 1040.94 233.26C1037.29 232.222 1034.13 230.787 1034.13 226.383C1034.13 222.517 1037.23 220 1042.29 220C1045.51 220 1048.46 220.873 1050.59 223.588L1047.03 226.595ZM1095.44 225.666C1096.36 225.629 1097.25 226.01 1097.87 226.706L1095.93 230.862C1095.45 230.494 1094.87 230.3 1094.27 230.312C1093.04 230.312 1091.98 231.394 1091.98 233.361V241.894H1087.12V225.971H1091.9V228.204C1092.76 226.676 1093.85 225.666 1095.44 225.666ZM1067.36 231.161V241.894H1062.56V232.895C1062.56 231.167 1061.65 230.109 1060.05 230.109C1058.45 230.109 1057.36 231.128 1057.36 232.955V241.894H1052.55V220.368H1057.36V228.111C1058.48 226.547 1060.28 225.633 1062.17 225.654C1065.11 225.654 1067.36 227.615 1067.36 231.161ZM1085.55 238.202V241.577C1084.65 241.93 1083.7 242.108 1082.73 242.104C1081.41 242.104 1080.08 241.679 1079.46 240.109C1078.41 241.305 1076.47 242.223 1074.26 242.223C1071.05 242.223 1068.98 240.543 1068.98 237.344C1068.98 234.213 1071.46 232.342 1075.29 232.342C1076.56 232.344 1077.83 232.505 1079.06 232.82V232.3C1079.06 230.506 1078.05 229.448 1075.96 229.448C1074.54 229.491 1073.19 230.043 1072.13 231.005L1069.5 227.956C1071.07 226.503 1073.62 225.421 1076.56 225.421C1081.1 225.421 1083.83 227.651 1083.83 231.828V237.407C1083.83 238.005 1084.13 238.304 1084.76 238.304C1085.03 238.302 1085.3 238.268 1085.56 238.202H1085.55ZM1079.07 235.472C1078.19 235.249 1077.28 235.13 1076.38 235.116C1074.72 235.116 1073.9 235.948 1073.9 237.087C1073.9 238.166 1074.63 238.946 1076.11 238.946C1077.69 238.946 1079.07 237.984 1079.07 236.525V235.472ZM1132.79 240.489C1132.82 240.923 1132.66 241.349 1132.36 241.656C1132.05 241.962 1131.64 242.118 1131.21 242.083C1130.21 242.083 1129.64 241.443 1129.64 240.489C1129.64 239.535 1130.22 238.893 1131.21 238.893C1131.64 238.857 1132.06 239.014 1132.36 239.321C1132.66 239.627 1132.82 240.054 1132.79 240.489ZM1132.53 240.489C1132.58 239.978 1132.34 239.484 1131.91 239.214C1131.48 238.943 1130.94 238.943 1130.52 239.214C1130.09 239.484 1129.85 239.978 1129.9 240.489C1129.9 241.386 1130.44 241.87 1131.22 241.87C1132.01 241.87 1132.53 241.392 1132.53 240.489ZM1131.53 240.674L1131.82 241.24H1131.51L1131.23 240.719H1130.89V241.24H1130.6V239.67H1131.25C1131.62 239.67 1131.83 239.867 1131.83 240.172C1131.85 240.39 1131.73 240.597 1131.53 240.674ZM1131.55 240.19C1131.55 240.02 1131.45 239.918 1131.25 239.918H1130.89V240.471H1131.21C1131.43 240.471 1131.55 240.402 1131.55 240.19ZM1046.31 254.373V247.915H1044.87V254.373H1046.31ZM1070.27 249.425C1068.87 249.425 1067.69 250.4 1067.69 251.958C1067.69 253.515 1068.86 254.499 1070.27 254.499C1071.67 254.499 1072.84 253.515 1072.84 251.958C1072.84 250.4 1071.65 249.425 1070.27 249.425ZM1070.27 253.234C1069.94 253.237 1069.63 253.1 1069.41 252.857C1069.19 252.614 1069.08 252.288 1069.11 251.958C1069.04 251.491 1069.24 251.024 1069.63 250.766C1070.02 250.509 1070.52 250.509 1070.9 250.766C1071.29 251.024 1071.49 251.491 1071.42 251.958C1071.45 252.288 1071.34 252.614 1071.12 252.857C1070.9 253.1 1070.59 253.237 1070.27 253.234ZM1043.28 250.983C1043.8 250.747 1044.13 250.216 1044.12 249.635C1044.12 248.693 1043.46 247.915 1041.97 247.915H1039.1V254.373H1042.09C1043.59 254.373 1044.31 253.611 1044.31 252.514C1044.34 251.827 1043.92 251.203 1043.28 250.983ZM1040.61 249.168H1041.8C1042.27 249.168 1042.59 249.386 1042.59 249.823C1042.59 250.259 1042.31 250.517 1041.78 250.517H1040.59L1040.61 249.168ZM1041.9 253.124H1040.61V251.713H1041.9C1042.42 251.713 1042.73 251.982 1042.73 252.415C1042.73 252.849 1042.43 253.124 1041.89 253.124H1041.9ZM1056.82 250.732C1056.42 249.889 1055.68 249.419 1054.57 249.419C1053.25 249.419 1052.07 250.265 1052.07 251.94C1052.07 253.614 1053.11 254.481 1054.55 254.481C1055.56 254.481 1056.41 254.068 1056.81 253.178L1055.64 252.58C1055.45 252.99 1055.03 253.243 1054.59 253.222C1053.92 253.222 1053.48 252.735 1053.48 251.952C1053.48 251.168 1053.98 250.693 1054.58 250.693C1055.03 250.676 1055.44 250.949 1055.61 251.375L1056.82 250.732ZM1078.02 250.732C1077.63 249.889 1076.89 249.419 1075.78 249.419C1074.46 249.419 1073.28 250.265 1073.28 251.94C1073.28 253.614 1074.32 254.481 1075.76 254.481C1076.77 254.481 1077.62 254.068 1078.02 253.178L1076.85 252.58C1076.65 252.99 1076.24 253.243 1075.8 253.222C1075.13 253.222 1074.69 252.735 1074.69 251.952C1074.69 251.168 1075.19 250.693 1075.78 250.693C1076.23 250.676 1076.65 250.949 1076.82 251.375L1078.02 250.732ZM1066.3 251.898C1067.04 251.575 1067.51 250.822 1067.49 249.999C1067.49 248.606 1066.48 247.907 1065.04 247.907H1062.36V254.364H1063.85V252.194H1064.77L1065.96 254.364H1067.69L1066.3 251.898ZM1064.95 250.905H1063.85V249.198H1064.95C1065.65 249.198 1065.97 249.497 1065.97 250.056C1065.97 250.517 1065.64 250.92 1064.95 250.92L1064.95 250.905ZM1051.61 253.297C1051.53 253.314 1051.45 253.292 1051.39 253.237C1051.33 253.183 1051.3 253.102 1051.31 253.022V251.348C1051.31 250.098 1050.49 249.428 1049.13 249.428C1048.36 249.428 1047.62 249.708 1047.03 250.218L1047.83 251.115C1048.14 250.826 1048.55 250.661 1048.97 250.648C1049.6 250.648 1049.91 250.968 1049.91 251.503V251.659C1049.53 251.564 1049.15 251.516 1048.77 251.515C1047.62 251.515 1046.88 252.077 1046.88 253.01C1046.88 253.943 1047.5 254.475 1048.47 254.475C1049.05 254.489 1049.61 254.259 1050.02 253.838C1050.19 254.238 1050.59 254.48 1051.01 254.436C1051.3 254.436 1051.58 254.383 1051.85 254.278V253.264C1051.77 253.292 1051.69 253.309 1051.61 253.315L1051.61 253.297ZM1049.9 252.759C1049.9 253.195 1049.49 253.485 1049.02 253.485C1048.56 253.485 1048.36 253.252 1048.36 252.926C1048.36 252.6 1048.61 252.328 1049.1 252.328C1049.38 252.333 1049.65 252.368 1049.91 252.433L1049.9 252.759ZM1083.17 254.355L1081.47 251.351L1083.05 249.599H1081.46L1079.78 251.5V247.912H1078.38V254.37H1079.8V253.207L1080.49 252.46L1081.56 254.367L1083.17 254.355ZM1061.97 254.355L1060.28 251.351L1061.87 249.581H1060.24L1058.59 251.482V247.895H1057.17V254.353H1058.59V253.207L1059.27 252.46L1060.34 254.367L1061.97 254.355ZM1035.36 249.572L1034.51 252.726L1033.48 249.596H1031.93L1033.83 254.421C1033.72 254.692 1033.45 254.851 1033.16 254.81C1032.96 254.807 1032.77 254.746 1032.6 254.634L1032.08 255.644C1032.41 255.88 1032.8 256.004 1033.21 256C1034.27 256 1034.91 255.402 1035.29 254.266L1036.85 249.596L1035.36 249.572ZM1029.83 249.369C1029.32 249.361 1028.83 249.559 1028.46 249.919V247.915H1027V254.373H1028.42V253.94C1028.77 254.321 1029.28 254.525 1029.79 254.499C1031.03 254.499 1031.97 253.503 1031.97 251.928C1031.97 250.352 1031.07 249.369 1029.83 249.369ZM1029.45 253.207C1029.07 253.221 1028.7 253.05 1028.46 252.747V251.165C1028.68 250.85 1029.04 250.66 1029.42 250.651C1030.05 250.651 1030.52 251.094 1030.52 251.931C1030.52 252.768 1030.1 253.207 1029.45 253.207Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 202H1152.38V201.625H1152V202ZM1152 274V274.375H1152.38V274H1152ZM1080 202V202.375H1152V202V201.625H1080V202ZM1152 202H1151.62V274H1152H1152.38V202H1152ZM1152 274V273.625H1080V274V274.375H1152V274Z",
    fill: "#785E32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10830_8003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M827.086 310H848.999C848.999 308.105 848.747 306.268 848.276 304.522H827.086V310Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.086 299.042H845.917C844.632 296.945 842.988 295.091 841.072 293.564H827.086V299.042Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.999 331C832.942 331 837.484 329.292 841.072 326.435H814.927C818.514 329.292 823.057 331 827.999 331Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.082 320.955H845.917C846.95 319.271 847.75 317.43 848.276 315.477H807.723C808.25 317.43 809.05 319.271 810.082 320.955Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.728 292.279H818.641L816.861 293.573L817.541 295.665L815.761 294.372L813.981 295.665L814.569 293.857C813.001 295.163 811.628 296.693 810.496 298.397H811.109L809.976 299.22C809.799 299.515 809.63 299.814 809.467 300.117L810.009 301.783L808.999 301.049C808.748 301.581 808.519 302.124 808.312 302.679L808.908 304.514H811.109L809.329 305.807L810.009 307.9L808.229 306.607L807.162 307.381C807.056 308.239 807 309.113 807 310H828C828 298.402 828 297.035 828 289C823.852 289 819.984 290.203 816.728 292.279ZM817.541 307.9L815.761 306.607L813.981 307.9L814.661 305.807L812.881 304.514H815.081L815.761 302.422L816.441 304.514H818.641L816.861 305.807L817.541 307.9ZM816.861 299.69L817.541 301.783L815.761 300.489L813.981 301.783L814.661 299.69L812.881 298.397H815.081L815.761 296.304L816.441 298.397H818.641L816.861 299.69ZM825.074 307.9L823.294 306.607L821.514 307.9L822.194 305.807L820.414 304.514H822.614L823.294 302.422L823.974 304.514H826.174L824.394 305.807L825.074 307.9ZM824.394 299.69L825.074 301.783L823.294 300.489L821.514 301.783L822.194 299.69L820.414 298.397H822.614L823.294 296.304L823.974 298.397H826.174L824.394 299.69ZM824.394 293.573L825.074 295.665L823.294 294.372L821.514 295.665L822.194 293.573L820.414 292.279H822.614L823.294 290.187L823.974 292.279H826.174L824.394 293.573Z",
    fill: "#A38150"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267.93 292C1267.93 292 1267.93 292.244 1267.93 292.293C1271.42 293.662 1270.1 297.084 1270.1 297.084L1263.73 317.491L1255.07 292.073H1243V292.44C1245.08 292.904 1246.08 296.521 1246.08 296.521L1254 318.591C1256.2 324.798 1260.3 326.02 1260.3 326.02L1265.36 328L1277.56 292.024L1267.93 292Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936 346V345.625H935.625V346H936ZM936 418H935.625V418.375H936V418ZM936 346V346.375H1008V346V345.625H936V346ZM1008 418V417.625H936V418V418.375H1008V418ZM936 418H936.375V346H936H935.625V418H936Z",
    fill: "#785E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.48 394.943C1029.11 394.92 1029.76 395.092 1030.17 395.594C1030.28 395.736 1030.38 395.892 1030.45 396.058L1029.37 396.612C1029.3 396.448 1029.19 396.302 1029.06 396.182C1028.91 396.07 1028.72 396.016 1028.53 396.03C1028.34 396.043 1028.16 396.123 1028.03 396.255C1027.78 396.528 1027.64 396.886 1027.65 397.256C1027.56 398.493 1028.17 398.794 1028.38 398.877C1028.67 398.961 1028.98 398.972 1029.28 398.911V398.203H1028.59L1028.59 398.184V397.223H1030.49V399.698C1029.99 399.874 1029.46 399.973 1028.93 399.992C1028.07 400.045 1027.31 399.845 1026.79 399.164C1026.49 398.731 1026.32 398.216 1026.31 397.686C1026.27 397.139 1026.37 396.589 1026.6 396.091C1026.75 395.783 1026.98 395.518 1027.26 395.321C1027.54 395.124 1027.87 395.001 1028.21 394.964C1028.3 394.953 1028.39 394.946 1028.48 394.943ZM988.196 394.923C988.751 394.924 989.289 395.116 989.719 395.468C989.816 395.56 989.904 395.663 989.979 395.775L989.108 396.442C989.064 396.378 989.015 396.318 988.961 396.261C988.805 396.093 988.602 395.977 988.378 395.928C988.164 395.875 987.94 395.897 987.74 395.988C987.698 396.011 987.662 396.041 987.633 396.079C987.604 396.116 987.583 396.159 987.572 396.205C987.561 396.251 987.56 396.299 987.569 396.346C987.578 396.392 987.596 396.436 987.624 396.475C987.774 396.62 987.961 396.721 988.164 396.769C988.632 396.882 989.081 397.062 989.498 397.303C989.679 397.431 989.826 397.602 989.926 397.8C990.026 397.999 990.076 398.218 990.072 398.44C990.092 399.958 988.101 400.265 987.01 399.725C986.709 399.584 986.446 399.374 986.242 399.111L987.113 398.438C987.231 398.58 987.375 398.698 987.537 398.787C987.74 398.9 987.972 398.955 988.204 398.944C988.388 398.944 988.655 398.901 988.752 398.724C988.796 398.633 988.804 398.529 988.775 398.433C988.745 398.337 988.679 398.256 988.591 398.206C988.41 398.105 988.217 398.025 988.017 397.97C987.555 397.862 987.118 397.666 986.73 397.393C986.558 397.238 986.43 397.041 986.358 396.822C986.287 396.602 986.274 396.367 986.322 396.142C986.442 395.454 987.07 395.067 987.717 394.971C987.874 394.939 988.035 394.923 988.196 394.923ZM992.439 394.923C992.994 394.923 993.533 395.116 993.963 395.468C994.06 395.559 994.147 395.661 994.223 395.771L993.352 396.439C993.308 396.375 993.259 396.314 993.205 396.258C993.049 396.09 992.846 395.973 992.621 395.924C992.408 395.872 992.184 395.893 991.984 395.984C991.942 396.007 991.906 396.037 991.876 396.075C991.847 396.112 991.827 396.156 991.816 396.202C991.805 396.248 991.804 396.296 991.813 396.342C991.821 396.389 991.84 396.433 991.868 396.472C992.018 396.616 992.205 396.718 992.408 396.766C992.876 396.879 993.325 397.058 993.742 397.299C993.923 397.428 994.07 397.599 994.17 397.797C994.27 397.995 994.32 398.215 994.316 398.437C994.336 399.955 992.345 400.262 991.254 399.721C990.953 399.581 990.69 399.37 990.486 399.108L991.355 398.436C991.474 398.579 991.618 398.698 991.78 398.787C991.984 398.9 992.215 398.955 992.447 398.944C992.631 398.944 992.898 398.904 992.995 398.724C993.039 398.633 993.048 398.529 993.018 398.433C992.988 398.337 992.922 398.256 992.835 398.206C992.654 398.105 992.461 398.025 992.261 397.97C991.799 397.862 991.361 397.666 990.973 397.393C990.801 397.238 990.673 397.041 990.602 396.821C990.53 396.602 990.518 396.367 990.566 396.142C990.686 395.454 991.314 395.067 991.961 394.971C992.118 394.939 992.278 394.923 992.439 394.923ZM1006.53 395.027L1007.74 397.913L1008.87 395.027H1010.2V399.875H1008.94V397.506L1007.97 399.905H1007.44L1006.44 397.493V399.875L1005.2 399.871V395.027H1006.53ZM1037.18 395.027L1038.39 397.913L1039.53 395.027H1040.87V399.875H1039.61V397.506L1038.64 399.905H1038.12L1037.12 397.493V399.875L1035.85 399.871V395.027H1037.18ZM983.971 395.027L985.866 399.882H984.471L984.157 399.048H982.529L982.196 399.882L980.874 399.871L982.756 395.027H983.971ZM1013.91 395.027L1015.8 399.882H1014.41L1014.09 399.048H1012.47L1012.14 399.882L1010.81 399.871L1012.69 395.027H1013.91ZM1024.26 395.027L1026.16 399.882H1024.76L1024.45 399.048H1022.82L1022.49 399.882L1021.16 399.871L1023.05 395.027H1024.26ZM1017.71 395.027L1019.29 397.593V395.027H1020.57V399.875H1019.38L1017.67 397.136V399.875L1016.4 399.871V395.027H1017.71ZM1047.69 395.027L1049.27 397.593V395.027H1050.55V399.875H1049.36L1047.65 397.136V399.875L1046.38 399.871V395.027H1047.69ZM998.547 395.027V396.138H996.394V396.939H998.146V397.963H996.394V398.754H998.696V399.871H995.094V395.027H998.547ZM1003.08 395.027V396.138H1001.75V399.871H1000.43V396.138H999.077V395.027H1003.08ZM1034.89 395.027V396.138H1032.74V396.939H1034.49V397.963H1032.74V398.754H1035.04V399.871H1031.43V395.027H1034.89ZM1045.41 395.027V396.138H1043.26V396.939H1045.01V397.963H1043.26V398.754H1045.56V399.871H1041.96V395.027H1045.41ZM1055.2 395.027V396.138H1053.87V399.871H1052.55V396.138H1051.2V395.027H1055.2ZM987.113 398.438C987.11 398.434 987.106 398.43 987.103 398.427L987.136 398.42L987.113 398.438ZM991.355 398.436C991.353 398.433 991.35 398.43 991.347 398.427L991.38 398.417L991.355 398.436ZM982.813 398.047H983.861L983.337 396.572L982.813 398.047ZM1012.75 398.047H1013.8L1013.27 396.572L1012.75 398.047ZM1023.1 398.047H1024.15L1023.63 396.572L1023.1 398.047ZM1055.21 391.331H961.17V387.637H1055.21V391.331ZM1048.61 383.947H1044.61L1044.48 383.077C1043.65 383.764 1042.63 384.174 1041.56 384.248C1040.61 384.291 1039.66 384.104 1038.8 383.701C1037.52 383.114 1034.94 381.245 1034.97 376.531C1034.96 374.555 1035.72 372.654 1037.09 371.23C1037.76 370.592 1039.28 369.258 1042.09 369.258C1042.83 369.26 1043.56 369.356 1044.26 369.545V364.334H1048.61V383.947ZM1009.33 377.705C1009.33 378.389 1009.47 380.011 1010.47 380.391C1011.27 380.651 1012.15 380.6 1012.92 380.247C1013.32 380.044 1013.7 379.805 1014.06 379.534V369.595H1018.45L1018.43 369.601V383.947H1014.43L1014.24 382.716C1013.87 383.087 1013.43 383.394 1012.95 383.624C1012.28 383.965 1011.55 384.167 1010.8 384.221C1009.18 384.334 1007.42 383.844 1006.33 382.63C1005.23 381.415 1004.95 379.67 1004.95 378.079V369.595H1009.33V377.705ZM1028.5 369.256C1029.7 369.259 1031.09 369.568 1032.11 370.462C1032.79 371.056 1033.93 372.431 1033.92 375.52V383.958H1029.54V375.82C1029.54 374.593 1029.19 373.582 1028.42 373.151C1028.03 372.959 1027.6 372.865 1027.17 372.875C1026.74 372.886 1026.32 373.001 1025.94 373.211C1025.51 373.448 1025.11 373.728 1024.75 374.049V383.944H1020.37V369.598H1024.37L1024.55 370.773C1025.15 370.204 1025.88 369.777 1026.67 369.522C1027.14 369.363 1027.79 369.254 1028.5 369.256ZM980.681 383.944H976.063L974.466 380.131H967.219L965.621 383.944H961L969.164 364.334H972.5L980.681 383.944ZM1055.2 383.944H1050.85V369.595H1055.2V383.944ZM997.636 369.258C998.093 369.258 1000.29 369.318 1001.7 370.592C1003.1 371.867 1003.32 373.842 1003.32 375.41V383.931H998.987V375.564C998.987 374.986 998.907 373.715 998.103 373.155C997.729 372.894 996.595 372.674 995.594 373.118C995.146 373.302 994.715 373.525 994.306 373.785C994.395 374.3 994.443 374.821 994.449 375.343V383.937H990.112V375.57C990.112 375.19 990.072 373.846 989.405 373.275C988.528 372.538 987.316 372.968 986.826 373.205C986.401 373.413 986.01 373.684 985.665 374.009V383.941H981.281V369.595H985.308L985.462 370.766C986.071 370.197 986.797 369.77 987.59 369.515C989.549 368.827 991.931 369.742 992.902 370.743C994.315 369.827 995.952 369.313 997.636 369.258ZM1042.61 372.885C1042.54 372.882 1042.48 372.882 1042.41 372.884C1041.78 372.903 1041.17 373.113 1040.66 373.485C1040.15 373.857 1039.76 374.375 1039.55 374.97C1039.23 375.84 1039.16 376.78 1039.34 377.688C1039.75 380.281 1041.68 380.978 1043.2 380.357C1043.61 380.208 1043.98 379.948 1044.26 379.607L1044.28 373.181C1043.74 372.991 1043.18 372.891 1042.61 372.885ZM968.497 376.411H973.168L970.832 370.295L968.497 376.411ZM1053.03 364C1054.63 364 1055.57 365.124 1055.57 366.335C1055.57 367.563 1054.71 368.671 1053.03 368.671C1051.34 368.671 1050.48 367.553 1050.48 366.335C1050.48 365.118 1051.43 364 1053.03 364Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 346H1080.38V345.625H1080V346ZM1080 418V418.375H1080.38V418H1080ZM1008 346V346.375H1080V346V345.625H1008V346ZM1080 346H1079.62V418H1080H1080.38V346H1080ZM1080 418V417.625H1008V418V418.375H1080V418Z",
    fill: "#785E32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408.96 393.185C1409.78 393.185 1410.72 393.534 1411.37 393.945L1410.49 395.126C1409.95 394.855 1409.32 394.655 1408.93 394.655C1408.18 394.655 1407.9 394.851 1407.9 395.12C1407.9 395.579 1408.84 395.665 1409.33 395.78C1410.53 396.063 1411.72 396.399 1411.72 397.873C1411.72 399.238 1410.3 400 1408.9 400C1407.87 400 1406.85 399.552 1406.15 399.091L1407 397.929C1407.62 398.25 1408.28 398.53 1409 398.53C1409.65 398.53 1410.04 398.268 1410.04 397.952C1410.04 397.493 1409.34 397.413 1409.02 397.354C1407.74 397.111 1406.23 396.87 1406.23 395.211C1406.23 393.974 1407.5 393.185 1408.96 393.185ZM1402.32 393.184C1404.15 393.184 1405.3 394.73 1405.3 396.597C1405.3 396.847 1405.29 396.941 1405.28 397.145H1400.97C1401.09 398 1401.8 398.379 1402.48 398.379C1402.87 398.379 1403.36 398.229 1403.7 397.8L1405.02 398.765C1404.31 399.738 1403.17 399.999 1402.48 399.999C1400.57 399.999 1399.21 398.665 1399.21 396.597C1399.21 394.592 1400.6 393.184 1402.32 393.184ZM1415.87 393.184C1417.02 393.184 1418.04 393.755 1418.66 394.628L1417.27 395.64C1416.99 395.16 1416.49 394.84 1415.87 394.84C1414.91 394.84 1414.21 395.63 1414.21 396.597C1414.21 397.564 1414.91 398.341 1415.87 398.341C1416.48 398.341 1416.98 398.035 1417.27 397.568L1418.65 398.574C1418.03 399.437 1417.02 399.999 1415.87 399.999C1413.99 399.999 1412.47 398.479 1412.47 396.597C1412.47 394.715 1413.99 393.184 1415.87 393.184ZM1422.56 393.183C1424.44 393.183 1425.97 394.715 1425.97 396.597C1425.97 398.479 1424.44 399.997 1422.56 399.997C1420.68 399.997 1419.15 398.479 1419.15 396.597C1419.15 394.715 1420.68 393.183 1422.56 393.183ZM1384.73 399.861H1383.01V391.636L1384.73 390.776V399.861ZM1389.47 393.183C1391.14 393.183 1391.89 394.33 1391.89 396.173V399.861H1390.17V396.323C1390.17 395.153 1389.77 394.803 1389.06 394.803C1388.35 394.803 1387.94 395.153 1387.94 396.285V399.861H1386.22V393.321H1387.94V393.757C1388.24 393.445 1388.78 393.183 1389.47 393.183ZM1395.3 396.348C1395.46 396.847 1395.64 397.468 1395.71 397.78C1395.79 397.456 1395.96 396.858 1396.12 396.348L1397.08 393.321H1398.93L1396.57 399.861H1394.8L1392.45 393.321H1394.34L1395.3 396.348ZM1422.56 394.84C1421.59 394.84 1420.9 395.63 1420.9 396.597C1420.9 397.564 1421.59 398.341 1422.56 398.341C1423.53 398.341 1424.22 397.564 1424.22 396.597C1424.22 395.63 1423.53 394.84 1422.56 394.84ZM1402.26 394.68C1401.61 394.68 1401.11 395.19 1401 395.851H1403.58C1403.49 395.221 1403.09 394.68 1402.26 394.68ZM1406.59 365.572L1409.73 368.722V371.874L1414.45 376.604L1419.17 379.756L1421.53 380.541L1422.31 382.902L1425.45 384.483L1423.88 386.059H1422.31L1422.31 384.48L1419.95 383.693L1416.02 379.751L1412.88 378.18L1409.73 373.45L1408.16 371.874L1408.95 369.512L1406.59 367.15L1405.01 368.727V371.878L1403.45 373.453L1406.59 376.6L1405.01 378.175L1408.16 381.331V382.907L1409.73 386.059H1411.3L1412.88 384.483L1412.09 383.695L1411.3 381.331H1412.88L1414.45 384.483L1416.02 386.054L1411.3 387.637L1409.74 389.209L1408.16 387.633L1407.38 385.268L1405.01 384.478L1405.02 382.904L1403.44 382.907L1402.66 386.844L1403.45 389.208L1399.82 390.779L1398.72 389.204L1399.51 387.629V386.059H1397.15L1394.01 389.209L1391.65 388.418V385.268L1387.72 384.645L1384.72 386.156L1383 385.296L1383 382.114L1384.57 381.331L1390.87 378.18L1391.65 378.966L1394.01 376.604V375.029L1397.15 371.878L1398.72 368.722L1401.09 364.786L1405.01 364H1406.59V365.572Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 418V417.625H1151.62V418H1152ZM1152 490H1151.62V490.375H1152V490ZM1152 418V418.375H1224V418V417.625H1152V418ZM1224 490V489.625H1152V490V490.375H1224V490ZM1152 490H1152.38V418H1152H1151.62V490H1152Z",
    fill: "#785E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.69 436L1184.15 462.525V467.687L1206.69 441.17V436ZM1195.54 440.313L1173 466.839V472L1195.54 445.475V440.313ZM1266.26 445.191C1259.72 445.191 1257.38 448.794 1257.38 452.159C1257.38 455.058 1258.77 457.191 1265.59 458.869C1268.32 459.507 1269.62 459.781 1269.62 461.605C1269.62 463.428 1268.05 464.431 1265.63 464.431C1264.01 464.431 1262.9 463.921 1262.31 462.899C1261.96 462.185 1261.79 461.391 1261.83 460.593V460.356H1256.65V460.547C1256.65 462.617 1256.75 468.116 1265.36 468.116C1271.05 468.116 1274.89 465.252 1274.93 460.985V460.857C1274.93 456.434 1270.65 455.385 1267.24 454.638L1267.23 454.628L1267.06 454.584C1263.99 453.836 1262.6 453.488 1262.6 451.683C1262.6 450.023 1263.94 448.947 1266.03 448.947C1266.46 448.897 1266.89 448.94 1267.31 449.075C1267.72 449.209 1268.1 449.431 1268.42 449.725C1268.74 450.02 1268.99 450.38 1269.16 450.78C1269.33 451.181 1269.41 451.614 1269.39 452.048V452.221H1274.3V452.039C1274.38 450.566 1273.95 449.109 1273.07 447.927C1271.15 445.565 1267.98 445.191 1266.26 445.191ZM1226.41 445.656L1231.71 467.66H1237.11L1241.16 452.021L1244.83 467.66H1250.41L1255.96 445.656H1251.06L1247.75 460.801L1244.11 445.656H1238.61L1234.82 460.83L1231.67 445.656H1226.41ZM1206.69 445.694V467.66H1213.64C1214.96 467.708 1216.28 467.628 1217.58 467.423C1219.75 467.036 1221.7 465.86 1223.05 464.121C1224.69 461.863 1225.52 459.114 1225.4 456.324C1225.4 454.127 1224.9 450.06 1221.63 447.644L1221.66 447.681C1219.83 446.359 1217.31 445.694 1214.06 445.694L1206.69 445.694ZM1214.44 449.633C1215.05 449.654 1215.65 449.726 1216.25 449.85C1219.58 450.762 1220.07 454.328 1220.07 456.362C1220.07 457.602 1219.89 460.647 1218.17 462.362V462.324C1216.84 463.655 1215.09 463.703 1213.27 463.703H1212.05V449.651H1213.38C1213.73 449.627 1214.08 449.621 1214.44 449.633Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296 418H1296.38V417.625H1296V418ZM1296 490V490.375H1296.38V490H1296ZM1224 418V418.375H1296V418V417.625H1224V418ZM1296 418H1295.62V490H1296H1296.38V418H1296ZM1296 490V489.625H1224V490V490.375H1296V490Z",
    fill: "#785E32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10830_8003",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1440 310) scale(851.5 228.892)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10830_8003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1080,
    fill: "white",
    transform: "translate(0 -230)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10830_8003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(807 289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtfs);
export default __webpack_public_path__ + "static/media/etfs.40cc93b84ff5bb7d6bf6a52028d54f0d.svg";
export { ForwardRef as ReactComponent };